import StudentPackageDetailAPI from '@/apis/business/student/student-package-detail-api.js'

export default {
  namespaced: true,

  state: {
    studentPackageDetail: null
  },

  getters: {},

  mutations: {
    /**
     * @description set dữ liệu cho state studentPackageDetail
     * @author PVThang
     * @param {*} state
     * @param {*} studentPackageDetail
     */
    setStudentPackageDetail (state, studentPackageDetail) {
      state.studentPackageDetail = studentPackageDetail
    }
  },

  actions: {
    /**
     * @author PVThang
     * @description Lấy StudentPackageDetail theo courseID
     */
    async getStudentPackageDetail (context, courseObjectId) {
      const res = await StudentPackageDetailAPI.getAsync(`course/${courseObjectId}`)

      return res?.Data
    },

    async getByStudentIDAndCourseID (context, params) {
      const res = await StudentPackageDetailAPI.getAsync(`student/${params.StudentID}/${params.CourseID}`)
      return res?.Data
    }

  }
}
